import http from '@utils/http'
/*
* 查询套餐详情
**/
export function buyPlanQuery(data): Promise<any> {
    return http.post('/sim/buyPlanQuery', data || {})
}
/*
* 加油包详情
**/
export function buyRefuelPackageQuery(data): Promise<any> {
    return http.post('/sim/buyRefuelPackageQuery', data || {})
}
/*
* 提交订单
**/
export function gobuyPlan(data): Promise<any> {
    return http.post('/sim/buyPlan', data || {})
}

/**
 * 支付
 */
export function payingPlan(data): Promise<any> {
    return http.post('/pay/thirdPayRequest', data || {})
}

/**
 * 服务升级
 * @param data
 */
export function upgradePlan(data): Promise<any> {
    return http.post('/simPlanChange/upgradePlan', data || {})
}


/**
 * 查询订单状态
 */
export function queryOrderStatus(data): Promise<any> {
    return http.post('pay/queryOrderStatus', data || {})
}

export function queryThirdOrderStatus(data): Promise<any> {
    return http.post('pay/queryThirdOrderStatus', data || {})
}

/**
 * 套餐详情页领券
 * @param data
 * @returns {Promise<any>}
 */
export function queryCouponList(data): Promise<any> {
    return http.post('/activity/queryCouponList', data || {})
}

/**
 * 查询抵扣积分信息
 * @param data
 * @returns {Promise<any>}
 */
export function queryUsedIntegral(data): Promise<any> {
    return http.post('/pay/queryUsedIntegral', data || {})
}
